
import { Component, Vue } from 'vue-property-decorator';

import config from '@/config';
import HomeTitle from '@/components/Home/HomeTitle.vue';
import HomeIntro from '@/components/Home/HomeIntro.vue';
import HomePoints from '@/components/Home/HomePoints.vue';
import OfferShow from '@/components/Home/OfferShow.vue';
import PartnersIntro from '@/components/Home/PartnersIntro.vue';
import ServiceProviders from '@/components/Home/ServiceProviders.vue';
import Footer from '@/components/Home/Footer.vue';

import * as common from '@/services/common/common';

@Component({
  components: {
    HomeTitle,
    HomeIntro,
    HomePoints,
    OfferShow,
    PartnersIntro,
    ServiceProviders,
    Footer,
  },
})
export default class Home extends Vue {
  iconPoint: string = require('@/assets/gif/tcl_point.gif');

  iconPartner: string = require('@/assets/gif/tcl_partner.gif');

  get isConnected(): boolean {
    return common.isConnected();
  }

  get compShowStickers() {
    return !this.$store.getters['platform/getPlatform'].style.hideStickers;
  }

  get compHeaderImage() {
    const image = this.$store.getters['platform/getPlatform'].style.headerImage;
    if (!image) {
      return '';
    }
    const headerImage = `${config.apiUrl}/api${image}`;
    return `background-image: url(${headerImage});`;
  }
}
